import isProduction from './isProduction';

const isE2 = () => !isProduction() && !__DEV__;

export default isE2;
